interface NetworkInformationLike {
  saveData?: boolean;
  effectiveType?: string;
}

/**
 * True on phones, slow connections or data-saver mode: lighter images are loaded
 * first (2048 px instead of the full resolution, which can weigh 10+ MB and exceed the GPU limits of phones).
 */
export function prefersLightImages(): boolean {
  if (typeof window === 'undefined') return false;
  const connection = (navigator as Navigator & { connection?: NetworkInformationLike }).connection;
  if (connection?.saveData) return true;
  if (connection?.effectiveType && /(^|-)2g$|^3g$/.test(connection.effectiveType)) return true;
  const smallScreen = Math.min(window.screen?.width ?? 1920, window.screen?.height ?? 1080) < 768;
  const coarse = window.matchMedia?.('(pointer: coarse)').matches ?? false;
  return smallScreen && coarse;
}
